import { components } from 'react-select'
import { CaretDownIcon } from '@phosphor-icons/react/dist/ssr/CaretDown'
import { XIcon } from '@phosphor-icons/react/dist/ssr/X'

const reactSelectColors = {
  primary25: '#ffe7b3',
  primary50: '#fcd37e',
  primary75: '#ffcf6b',
  primary: '#ffc857',
}
const menuPortalZIndex = 80

export const reactSelectTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    ...reactSelectColors,
  },
})

export const getReactSelectStyles = (isClassicSelect: boolean) => {
  return {
    control: (styles) => ({
      ...styles,
      fontSize: '14px',
      minHeight: '40px',
      borderRadius: '6px',
      border: '1px solid rgb(209 213 219)',
      cursor: 'pointer',
    }),
    option: (styles, state) => ({
      ...styles,
      color: state.isFocused ? '#1f1e1e' : '#343232',
      fontSize: '14px',
      innerWidth: '100%',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontSize: '14px',
    }),
    menuPortal: (styles) => ({
      ...styles,
      zIndex: menuPortalZIndex,
    }),
    ...(isClassicSelect && {
      placeholder: (styles) => ({
        ...styles,
        color: '#000',
      }),
    }),
  }
}

export const reactSelectStyles = {
  control: (styles) => ({
    ...styles,
    fontSize: '14px',
    minHeight: '40px',
    borderRadius: '6px',
    border: '1px solid rgb(209 213 219)',
    cursor: 'pointer',
  }),
  option: (styles, state) => ({
    ...styles,
    color: state.isFocused ? '#1f1e1e' : '#343232',
    fontSize: '14px',
    innerWidth: '100%',
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    fontSize: '14px',
  }),
  menuPortal: (styles) => ({
    ...styles,
    zIndex: menuPortalZIndex,
  }),
}

export const darkReactSelectStyles = {
  control: (styles) => ({
    ...styles,
    fontSize: '14px',
    minHeight: '40px',
    borderRadius: '6px',
    border: '1px solid rgb(52 50 50)',
    cursor: 'pointer',
    backgroundColor: '#1f1e1e',
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: '#d1d5db',
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    border: '0.5px solid #343232',
  }),
  menuList: (styles) => ({
    ...styles,
    backgroundColor: '#1f1e1e',
  }),
  option: (styles, state) => ({
    ...styles,
    color: state.isFocused ? '#343232' : '#d1d5db',
    fontSize: '14px',
    innerWidth: '100%',
    backgroundColor: state.isFocused ? '#ffc857' : '#1f1e1e',
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    fontSize: '14px',
  }),
  menuPortal: (styles) => ({
    ...styles,
    zIndex: menuPortalZIndex,
  }),
  singleValue: (styles) => ({
    ...styles,
    color: '#d1d5db',
  }),
}

export const filterConfig = {
  ignoreCase: true,
  ignoreAccents: true,
  trim: true,
}

export const ClearIndicator = (props: any) => {
  return (
    <components.ClearIndicator {...props}>
      <div className="cursor-pointer">
        <XIcon className="size-5" />
      </div>
    </components.ClearIndicator>
  )
}

export const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <div className="cursor-pointer">
        <CaretDownIcon className="size-5" />
      </div>
    </components.DropdownIndicator>
  )
}
